/* @typescript-eslint/no-unused-vars*/
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
};

const staggerChildren = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2
        }
    }
};

interface TeamMember {
    name: string;
    position: string;
    bio: string;
    imageUrl: string;
    linkedIn?: string;
    twitter?: string;
    instagram?: string;
    facebook?: string;
}

interface CoreValue {
    title: string;
    description: string;
    icon: string;
}

const teamMembers: TeamMember[] = [
    {
        name: 'Mackenson Mesidor',
        position: 'CEO & IT Manager',
        bio: "Visionnaire technologique avec plus de 12 ans d'expérience dans le développement de solutions numériques innovantes. En tant que CEO et IT Manager de Kolabo Tech, Mackenson dirige l'équipe avec passion, favorisant l'innovation et guidant la croissance stratégique de l'entreprise dans le secteur technologique.",
        imageUrl: '/images/team/mackenson.webp',
        linkedIn: 'https://www.linkedin.com/in/mackenson-mesidor',
        twitter: 'https://twitter.com/mmesidor7',
        instagram: 'https://www.instagram.com/mesidormackensonlegrand',
        facebook: 'https://web.facebook.com/mesidormackensonlegrand'
    },
    {
        name: 'Rodolph P. D. Fidele',
        position: 'CTO & DevOps Engineer',
        bio: "En tant que CTO et DevOps Engineer chez Kolabo Tech, Rodolph excelle dans l'architecture des systèmes complexes et l'automatisation des processus. Expert en déploiement continu, il dirige l'innovation technique, optimise nos processus de développement et assure la robustesse de notre infrastructure cloud.",
        imageUrl: '/images/team/Rd.webp',
        linkedIn: 'https://www.linkedin.com/in/dolphfi',
        twitter: 'https://twitter.com/dolphfi_',
        instagram: 'https://www.instagram.com/dolphfi_',
        facebook: 'https://www.facebook.com/dolphfi'
    },
    {
        name: 'Wislin Herntz Prophète',
        position: 'Lead Developer ',
        bio: "Lead Developer chez Kolabo Tech, Wislin est un expert chevronné en développement web et mobile. Sa maîtrise des technologies modernes et sa vision innovante lui permettent de diriger efficacement les équipes de développement, assurant la livraison de solutions technologiques de haute qualité et la réussite des projets complexes.",
        imageUrl: '/images/team/herntz.webp',
        linkedIn: 'https://www.linkedin.com/in/wislin-herntz',
        twitter: 'https://x.com/HerntzWislin',
        instagram: 'https://www.instagram.com/wisherntz',
        facebook: 'https://www.facebook.com/wisherntz'
    },
    {
        name: 'André Cius',
        position: 'Community Manager',
        bio: "Community Manager créatif et passionné de photographie, spécialisé dans la gestion et l'animation des réseaux sociaux. Expert en création de contenu visuel et en stratégie de communication digitale pour renforcer l'engagement et la visibilité de la marque.",
        imageUrl: '/images/team/andre.webp',
        linkedIn: 'https://www.linkedin.com/in/andrecius',
        twitter: 'https://x.com/ciusandre',
        instagram: 'https://www.instagram.com/ander_photographe',
        facebook: 'https://www.facebook.com/Cius.Steevens'
    },
    // {
    //     name: 'Maria Garcia',
    //     position: 'UI/UX Designer',
    //     bio: "UI/UX Designer talentueuse chez Kolabo Tech, Maria allie créativité et méthodologie pour concevoir des expériences utilisateur exceptionnelles. Son expertise en design d'interface et sa compréhension approfondie des besoins utilisateurs lui permettent de créer des solutions à la fois esthétiques, intuitives et fonctionnelles.",
    //     imageUrl: '/images/team/maria.webp',
    //     linkedIn: 'https://www.linkedin.com/in/maria-garcia',
    //     twitter: 'https://twitter.com/maria-garcia',
    //     instagram: 'https://www.instagram.com/maria-garcia',
    //     facebook: 'https://www.facebook.com/maria-garcia'
    // },
    // {
    //     name: 'Sophie Chen',
    //     position: 'Lead Developer Backend',
    //     bio: "Spécialiste des architectures cloud et des systèmes distribués, Sophie assure la robustesse et la scalabilité de nos solutions.",
    //     imageUrl: '/images/kolabotech.webp',
    //     linkedIn: 'https://www.linkedin.com/in/sophie-chen',
    //     twitter: 'https://twitter.com/sophie-chen',
    //     instagram: 'https://www.instagram.com/sophie-chen',
    //     facebook: 'https://www.facebook.com/sophie-chen'
    // },
    // {
    //     name: 'Thomas Dubois',
    //     position: 'Product Manager',
    //     bio: "Thomas excelle dans la transformation des besoins clients en solutions concrètes, guidant nos produits de la conception au déploiement.",
    //     imageUrl: '/images/kolabotech.webp',
    //     linkedIn: 'https://www.linkedin.com/in/thomas-dubois',
    //     twitter: 'https://twitter.com/thomas-dubois',
    //     instagram: 'https://www.instagram.com/thomas-dubois',
    //     facebook: 'https://www.facebook.com/thomas-dubois'
    // },
    // {
    //     name: 'Emma Wilson',
    //     position: 'Data Scientist',
    //     bio: "Experte en IA et analyse de données, Emma développe des solutions intelligentes qui donnent un avantage compétitif à nos clients.",
    //     imageUrl: '/images/kolabotech.webp',
    //     linkedIn: 'https://www.linkedin.com/in/emma-wilson',
    //     twitter: 'https://twitter.com/emma-wilson',
    //     instagram: 'https://www.instagram.com/emma-wilson',
    //     facebook: 'https://www.facebook.com/emma-wilson'
    // }
];

const coreValues: CoreValue[] = [
    {
        title: 'Excellence',
        description: "Nous visons l'excellence dans tout ce que nous faisons, de la qualité du code à la communication client.",
        icon: '🎯'
    },
    {
        title: 'Innovation',
        description: "Nous adoptons les nouvelles technologies et des approches créatives pour résoudre des problèmes complexes.",
        icon: '💡'
    },
    {
        title: 'Collaboration',
        description: "Nous croyons en la force du travail d'équipe et du partenariat avec nos clients.",
        icon: '🤝'
    },
    {
        title: 'Intégrité',
        description: "Nous menons nos activités avec honnêteté, transparence et pratiques éthiques.",
        icon: '🛡️'
    }
];

const container = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2
        }
    }
};

const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.5
        }
    }
};

const AboutSection: React.FC = () => {
    const { ref } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    return (
        <section ref={ref} className="py-20 bg-gray-50 dark:bg-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* En-tête de la section */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                        À propos de nous
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
                        KOLABO TECH est une entreprise de développement logiciel innovante basée en Haïti,
                        spécialisée dans la création de solutions numériques sur mesure pour les entreprises.
                    </p>
                </motion.div>

                {/* Section Notre Histoire */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    transition={{ duration: 0.6 }}
                    className="mb-20">
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">
                        Notre Histoire
                    </h3>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <motion.div
                            variants={fadeInUp}
                            transition={{ delay: 0.2 }}
                            className="text-gray-600 dark:text-gray-300 space-y-6 text-left">
                            <p>
                                Fondée en 2019, KOLABO TECH a commencé avec une mission simple : aider les entreprises à exploiter
                                la puissance de la technologie pour atteindre leurs objectifs. Ce qui a commencé comme une petite équipe
                                de développeurs est devenu un fournisseur complet de solutions numériques.
                            </p>
                            <p>
                                Nous croyons que la technologie doit être accessible, intuitive et transformative. Notre approche combine
                                expertise technique et réflexion stratégique pour fournir des solutions qui répondent non seulement aux
                                besoins actuels mais sont également conçues pour la croissance future.
                            </p>
                            <p>
                                Aujourd'hui, nous sommes fiers de travailler avec des clients de différents secteurs, des startups aux
                                entreprises établies, les aidant à naviguer dans le paysage numérique et à rester en avance sur la concurrence.
                            </p>
                        </motion.div>
                        <motion.div variants={fadeInUp} className="bg-gray-100 dark:bg-gray-800 rounded-xl overflow-hidden h-52">
                            {/* Espace réservé pour l'image */}
                            <div className="w-full h-full flex items-center justify-center">
                                {/* <span className="text-sm">Image à ajouter</span> */}
                                <img src="/images/kolabotech.webp" alt="About" className="w-full h-full object-cover" />
                            </div>
                        </motion.div>
                    </div>
                </motion.div>

                {/* Section Mission et Vision */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={staggerChildren}
                    className="mb-20 grid md:grid-cols-2 gap-12">
                    <motion.div
                        variants={fadeInUp}
                        className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
                        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                            Notre mission
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300">
                            Pour autonomiser les entreprises ayant des solutions technologiques innovantes qui stimulent
                            la croissance, l'efficacité et l'avantage concurrentiel. Nous nous efforçons d'être un
                            partenaire de confiance dans le parcours de transformation numérique de nos clients, offrant
                            l'excellence dans chaque projet que nous entreprenons.
                        </p>
                    </motion.div>
                    <motion.div
                        variants={fadeInUp}
                        className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
                        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                            Notre vision
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300">
                            Être à l'avant-garde de l'innovation technologique, reconnue à l'échelle mondiale pour notre
                            expertise, notre intégrité et l'impact transformateur de nos solutions. Nous envisageons un
                            avenir où la technologie améliore le potentiel humain et crée une valeur durable pour les
                            entreprises et la société.
                        </p>
                    </motion.div>
                </motion.div>

                {/* Section des valeurs fondamentales */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={staggerChildren}
                    className="mb-20">
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white text-center mb-12">
                        Nos valeurs fondamentales
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {coreValues.map((value, index) => (
                            <motion.div
                                key={value.title}
                                variants={fadeInUp}
                                className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 text-center"
                            >
                                <div className="text-4xl mb-4">{value.icon}</div>
                                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                    {value.title}
                                </h4>
                                <p className="text-gray-600 dark:text-gray-300">
                                    {value.description}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Section de l'équipe */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={container}
                >
                    <motion.h3
                        variants={item}
                        className="text-2xl font-bold text-gray-900 dark:text-white text-center mb-12"
                    >
                        Notre équipe
                    </motion.h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {teamMembers.map((member, index) => (
                            <motion.div
                                key={member.name}
                                variants={item}
                                className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden"
                            >
                                <div className="aspect-w-1 aspect-h-1">
                                    <img
                                        src={member.imageUrl}
                                        alt={member.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="p-6">
                                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                        {member.name}
                                    </h4>
                                    <p className="text-indigo-600 dark:text-indigo-400 mb-4">
                                        {member.position}
                                    </p>
                                    <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                                        {member.bio}
                                    </p>
                                    <div className="flex space-x-4">
                                        {member.linkedIn && (
                                            <a href={member.linkedIn} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-500">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
                                            </a>
                                        )}
                                        {member.twitter && (
                                            <a href={member.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-500">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
                                            </a>
                                        )}
                                        {member.instagram && (
                                            <a href={member.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-500">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" /></svg>
                                            </a>
                                        )}
                                        {member.facebook && (
                                            <a href={member.facebook} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-500">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" /></svg>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default AboutSection;